export var purchaseActionTriggers = {
  LIMITED_TIME_OFFER_BUY_BUTTON: 'LIMITED_TIME_OFFER_BUY_BUTTON',
  STORE_COIN_ITEM: 'STORE_COIN_ITEM_BUY_BUTTON',
  STORE_VIP_ITEM: 'STORE_VIP_ITEM_BUY_BUTTON',
  PERSONALIZED_OFFER_BUY_BUTTON: 'PERSONALIZED_OFFER_BUY_BUTTON',
  OUT_OF_COINS_BUY_BUTTON: 'OUT_OF_COINS_BUY_BUTTON'
};